var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomatedTrafficFineNotificationAuthenticationShowInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 7.5,
    stroke: "#E9E9E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5127_27365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.834 21.9997C12.834 21.9997 16.1673 15.333 22.0007 15.333C27.834 15.333 31.1673 21.9997 31.1673 21.9997C31.1673 21.9997 27.834 28.6663 22.0007 28.6663C16.1673 28.6663 12.834 21.9997 12.834 21.9997Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0007 24.4997C23.3814 24.4997 24.5006 23.3804 24.5006 21.9997C24.5006 20.619 23.3814 19.4997 22.0007 19.4997C20.6199 19.4997 19.5007 20.619 19.5007 21.9997C19.5007 23.3804 20.6199 24.4997 22.0007 24.4997Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5127_27365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedTrafficFineNotificationAuthenticationShowInfo);
export default __webpack_public_path__ + "static/media/AutomatedTrafficFineNotificationAuthenticationShowInfo.a00543b4d9544ac667e97cd3a4f0aa25.svg";
export { ForwardRef as ReactComponent };